<template>
  <article ref="scrollBox" class="home">

    <swiper
    :swiperImgArray="advertList"
    :swiperWrapClass="swiperClass">
    </swiper>

   <scope-primary-nav
    :primaryNavArr="primaryNavList"
    @changedScopeId="changedScopeId($event)"
    ></scope-primary-nav>

    

    <bus-ticket-condition v-if="currentScopeId == -1"></bus-ticket-condition>

    <boat-ticket-condition v-if="currentScopeId == -2"></boat-ticket-condition>

    <scope-menu-list
      v-if="currentScopeId > 0"
      :goodsList="goodsList"
      :secondNav="secondNav"
      :secondNavItem="secondNavItem"
      @changedScopeClassify="changedScopeClassify($event)"
    ></scope-menu-list>
  </article>
</template>

<script>

import Swiper from './child-components/Swiper'

import scopeApi from '../request/scopeApi';
// import ScopeAdvertSwiper from './child-components/ScopeAdvertSwiper';
import BusTicketCondition from './child-components/BusTicketCondition';
import ScopeMenuList from './child-components/ScopeMenuList';
import ScopePrimaryNav from './child-components/ScopePrimaryNav';
import BoatTicketCondition from './child-components/BoatTicketCondition';
import NavFooter from './child-components/NavFooter';

export default {
  name: 'ScopeIndex',
  data() {
    return {
      primaryNavList: [],
      currentScopeId: -1,
      secondNav: [],
      goodsList: [],
      secondNavItem: {},
      autoPlay: true,
      swiperClass: 'big_banner_wrap',
      // swiperImgList: [],
      advertList: []
    };
  },
  components: {
    BusTicketCondition,
    ScopeMenuList,
    ScopePrimaryNav,
    'swiper':Swiper,
    // ScopeAdvertSwiper,
    BoatTicketCondition,
    NavFooter
  },
  mounted() {
    // this.getScopeTypeList();
    this.getAdvertList();
  },
  methods: {
    getAdvertList() {
      let that = this;
      this.advertList = [];
      scopeApi.getAdvertInfoList(2).then(sucRes => {
        if (sucRes.success) {
          for (let i = 0; i < sucRes.data.length; i++) {
            that.advertList.push(sucRes.data[i].GoodsLogoUrl);
          }
        }
      });
      this.advertList.push('http://www.callmefix.net/api/Event/getImage?type=3&name=38');
    },

    changedScopeId(scopeId) {
      if (scopeId <= 0) {
        this.currentScopeId = scopeId;
      } else {
        this.currentScopeId = scopeId;
        this.secondNav = [];
        this.GoodsList = [];
        this.selectSecondNav(this.currentScopeId);
      }
    },
    changedScopeClassify(scopeClassify) {
      this.scopeClassify = scopeClassify;
      this.getGoodsList(this.scopeClassify);
    },
    getScopeTypeList() {
      scopeApi.getScopeTypeList(2).then(sucRes => {
        this.primaryNavList = sucRes.data;
      });
    },
    //通过点击主导航获取二级
    selectSecondNav(scopeid) {
      for (let i = 0; i < this.primaryNavList.length; i++) {
        if (this.primaryNavList[i].ID == scopeid) {
          this.secondNav = this.primaryNavList[i].ScopeType_Classifys;
          if (this.secondNav && this.secondNav.length > 0) {
            this.getGoodsList(this.secondNav[0]);
          }
        }
      }
    },
    getGoodsList(secondNavItem) {
      let that = this;
      this.secondNavItem = secondNavItem; //业务类型子分类赋值到data:businessSubItem
      scopeApi.getScopeGoodsList(secondNavItem.ID).then(sucRes => {
        console.log(sucRes);
        that.goodsList = sucRes.data;
      });
    }
  }
};
</script>

<style scoped lang="less">
  @import '../style/public';
  @import "../style/home.less";
</style>



// WEBPACK FOOTER //
// src/components/ScopeIndex.vue